import {css} from "@emotion/css";
import React, {useEffect, useRef, useState} from "react";
import useDraggableScroll from "use-draggable-scroll";
import PropTypes from "prop-types";
import "./RaikoSelectBox.scss"
import {Skeleton} from "@mui/material";

export const RaikoSelectBox = (
    {
        items = [],
        changeSelectItem,
        defaultSelectedItem,
        className,
        loading = false
    }) => {

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedItemId(items[0].id)
        }
    }, [items])

    const [selectedItemId, setSelectedItemId] =
        useState(
            defaultSelectedItem ? defaultSelectedItem :
                items.length > 0 && items[0].id ? items[0].id
                    : -1);


    function handleNewSelect(id) {
        setSelectedItemId(id)
        changeSelectItem(id)
    }

    return (
        <section className={`raikoSelectBoxContainer ${className}`} ref={ref} onMouseDown={onMouseDown}>

            <div className={"boxItemsContainer"}>
                {!loading && items.map((item, listIndex) => {
                    return <div
                        key={listIndex}
                        className={`raikoSelectBoxItems  
                            ${selectedItemId === item.id && "raikoSelectBoxItemActive "}`}
                        onClick={_ => handleNewSelect(item.id)}>

                        {item.icon &&
                            <div className={css`
                              border-radius: var(--default-border-radius);
                              width: fit-content;
                              height: fit-content;
                            `} id="filesIconContainer">
                                <div className={`${css`
                                  padding: 20px;
                                `} ${item.icon}`}
                                     id="filesIcon"
                                />
                            </div>
                        }

                        <p id="filesTitle">{item.title}</p>
                    </div>
                })}
            </div>

            {loading &&
                <div className={css`
                  display: flex;
                  flex-wrap: nowrap;
                  gap: .5rem;
                  width: 100%;
                  overflow: hidden`}>
                    {
                        [...Array(4)].map((item) => {
                            return <Skeleton
                                variant="rectangular"
                                className={css`
                                  height: 110px !important;
                                  width: 170px;
                                `}/>
                        })
                    }
                </div>
            }


        </section>
    )
}

RaikoSelectBox.propTypes = {
    items: PropTypes.array.isRequired,
    changeSelectItem: PropTypes.func.isRequired,
    loading: PropTypes.bool
}

export function prepareRaikoSelectBoxItem(id, title, iconClass = "ic-files") {
    return {
        id,
        title,
        icon: iconClass
    }
}